"use client";

import { useState, useEffect } from 'react';

export type DeviceType = 'ios' | 'android' | 'desktop' | 'unknown';

interface DeviceInfo {
  type: DeviceType;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  userAgent: string;
}

export const useDeviceDetection = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    type: 'unknown',
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    userAgent: ''
  });

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      
      // iOS detection
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      
      // Android detection
      const isAndroid = /android/.test(userAgent);
      
      // Tablet detection
      const isTablet = /tablet|ipad|playbook|silk/.test(userAgent) || 
                      (userAgent.includes('mobile') && !userAgent.includes('mobi'));
      
      // Mobile detection
      const isMobile = /mobile|android|iphone|ipad|ipod|blackberry|opera mini|iemobile/.test(userAgent);
      
      // Desktop detection
      const isDesktop = !isMobile && !isTablet;
      
      let deviceType: DeviceType = 'unknown';
      
      if (isIOS) {
        deviceType = 'ios';
      } else if (isAndroid) {
        deviceType = 'android';
      } else if (isDesktop) {
        deviceType = 'desktop';
      }

      setDeviceInfo({
        type: deviceType,
        isMobile,
        isTablet,
        isDesktop,
        userAgent
      });
    };

    detectDevice();
  }, []);

  return deviceInfo;
}; 